module.exports = __webpack_public_path__ + "static/product-updates@2x-15de89374b05e55baad740cde92e292a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/product-updates@2x.png
// module id = 2696
// module chunks = 157636680307020